import React from "react";
import LeadByteForm from "./LeadByteForm.js";
import "./LeadByteForm.css";

function App() {
  return (
    <div className="App">
      <LeadByteForm />
    </div>
  );
}

export default App;

